import React from 'react';
import {
    Field,
    FieldDescription,
    FieldError,
    FieldGroup,
    FieldLabel,
    FieldLegend,
    FieldSet
} from "@root/server/client/esweb/components/ui/field";
import {Control, Controller, FieldPath, FieldValues} from "react-hook-form";
import {Checkbox} from "@root/server/client/esweb/components/ui/checkbox";

let ix = 0;

export function RhfCheckbox<FORM_TYPE extends FieldValues>(params: {
    name: FieldPath<FORM_TYPE>
    label: string,
    legend?: string,
    description?: string,
    control: Control<FORM_TYPE>,
    className?: string
}) {
    const id = `rhfcheckbox-${ix++}`;

    const {
        name,
        label,
        control,
        legend,
        description,
        className
    } = params;

    return  <Controller
        {...{control, name}}
        render={({ field, fieldState }) => (
            <FieldSet data-invalid={fieldState.invalid} {...{className}}>
                {legend && <FieldLegend variant="label">{legend}</FieldLegend>}
                {description && <FieldDescription>{description}</FieldDescription>}

                <FieldGroup data-slot="checkbox-group">
                    <Field orientation="horizontal">
                        <Checkbox
                            id={id}
                            name={field.name}
                            checked={field.value as boolean}
                            onCheckedChange={field.onChange}
                            className="bg-white"
                        />
                        <FieldLabel
                            htmlFor={id}
                            className="font-normal"
                        >
                            {label}
                        </FieldLabel>
                    </Field>
                </FieldGroup>
                {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                )}
            </FieldSet>
        )}
    />
}